<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="ouverture_ouinon"
      :live="liveSasSociete(25928)"
      v-model="sasSociete.declarerLOuvertureDUneOuDePlusieursPharmacies"
      ref="ouvertureOuiNon"
      :disabled="!estSocieteProprietaire"
    />
    <data-iterator
      :list="sas.ouvertures"
      add-new-text="Ajouter une pharmacie"
      :live="{ endpoint: 'sas-ouverture', sasId: sas.id }"
      :icon="$getIcon('expPro')"
      :valids="valids"
      ref="dataIterator"
      :opqIf="conditionOuverture"
      @addItem="addPosteCanadaConfig"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.adresseLigne1 }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive
          code="ouverture_adresse_ligne_1"
          v-model="item.adresseLigne1"
          :live="liveSasOuverture(26202, item)"
          :ref="getId('adresse', item)"
          :id="getId('adresse-field', item)"
        />
        <TextFieldLive
          code="ouverture_adresse_ligne_2"
          v-model="item.adresseLigne2"
          :live="liveSasOuverture(26203, item)"
          :ref="getId('completementDAdresse', item)"
        />
        <TextFieldLive code="ouverture_ville" v-model="item.ville" :live="liveSasOuverture(26204, item)" :ref="getId('ville', item)" />
        <TextFieldLive code="ouverture_codepostal" v-model="item.codePostal" :live="liveSasOuverture(26205, item)" :ref="getId('codePostal', item)" />
        <CatalogueLive
          code="ouverture_province"
          v-model="item.province"
          :live="liveSasOuverture(26206, item)"
          :filter="(fd) => fd.code === 'QC'"
          :ref="getId('province', item)"
        />
        <CatalogueLive
          code="ouverture_pays"
          v-model="item.pays"
          :live="liveSasOuverture(26207, item)"
          :filter="(fd) => fd.code === 'CA'"
          :ref="getId('pays', item)"
        />
        <TextFieldLive code="ouverture_telephone" v-model="item.telephone" :live="liveSasOuverture(26208, item)" />
        <TextFieldLive code="ouverture_telecopieur" v-model="item.telecopieur" :live="liveSasOuverture(26209, item)" />
        <CatalogueLive code="ouverture_cpo_ouinon" v-model="item.centreDePreparationDOrdonnance" :live="liveSasOuverture(26210, item)" />
        <DatePickerLive code="ouverture_date" v-model="item.dateDOuverture" :live="liveSasOuverture(26212, item)" :minValue="serverDate()" />
        <FileInput
          code="ouverture_bail_ou_titrepropriete"
          :file="item.documentsJustificatifs"
          :live="liveSasOuverture(26211, item)"
          :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
        />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import PosteCanada from "@/mixins/PosteCanada"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, PosteCanada, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  data() {
    return {
      loadPosteCanadaOnMount: false,
      prefixPosteCanada: "ouverture_modification"
    }
  },
  mounted() {
    for (const ouverture of this.sas.ouvertures) {
      this.addPosteCanadaConfig(ouverture)
    }
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionOuverture() {
      return this.estOui(this.sas.sasSociete.declarerLOuvertureDUneOuDePlusieursPharmacies) && this.estSocieteProprietaire
    },
    estSocieteProprietaire() {
      return this.getCatalogueCodeById("335", this.sas.sasSociete.categorieDeSociete) !== "spnp"
    }
  },
  methods: {
    liveSasOuverture(cle, item) {
      return { endpoint: "sas-ouverture", cle: cle, fileId: item.id }
    },
    liveSasSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
    desactiverAjout() {
      if (!this.estSocieteProprietaire) {
        this.$refs.ouvertureOuiNon.setValueByCode("N")
      } else {
        this.sasSociete.declarerLOuvertureDUneOuDePlusieursPharmacies = null
      }
    }
  }
}
</script>

<style></style>